<template>
    <div class="p-2" style="width:275px">
      <vs-row vs-type="flex" vs-justify="center">
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" >
          {{$t('Actual')}} : {{ initialLocation }}
        </vs-col>
      </vs-row>
      <div class="vx-row ml-2 mr-2 mt-2 border border-solid d-theme-border-grey-light border-r-0 border-b-0 border-l-0">
        <vs-row class="mt-2">
          <vs-col class="mb-1" vs-w="12">            
            <vs-chip class="mt-2 mr-2" color="primary" >
              {{$t('GradeControl.Timesheet.TimesheetOperationType')}}
            </vs-chip>
            <v-select
              label="name"
              :options="timesheetOperationTypes"
              :reduce="v => v.id"
              v-model="timesheetOperationType"
              @input="setSelectedTimesheetOperationType"
              class="w-full"
              name="timesheetOperationType"
            />
          </vs-col>
        </vs-row>

        <vs-row v-if="isMuckOperationSelected || isHaulingOperationSelected">
          <vs-col class="mb-3" vs-w="12">
            <form-label>{{$t('GradeControl.Location.Type')}}</form-label>
            <v-select
              label="name"
              :options="locationTypes"
              :reduce="type => type.id"
              v-model="locationType"
              @input="setType"
              class="w-full"
              name="locationType"
            />
          </vs-col>
        </vs-row>
        <vs-row v-if="isMuckOperationSelected || isHaulingOperationSelected">
          <vs-col class="mb-1" vs-w="12">
            <form-label>{{$t('GradeControl.Location.Name')}}</form-label>
            <v-select
              label="code"
              :options="locations"
              :reduce="location => location.locationId"
              v-model="locationId"
              @input="setSelectedLocationId"
              class="w-full"
              name="locationId"
            />
            <small v-if="showActualLocation">{{ $t('Actual') }}: {{ locationCode }}</small>
          </vs-col>
        </vs-row>
        
        <vs-row v-if="isRemuckOperationSelected">
          <vs-col class="mb-1" vs-w="12">
            <form-label>{{$t('GradeControl.Timesheet.Source')}}</form-label>
            <v-select
              label="name"
              :options="sourceDestinations"
              :reduce="destination => destination.name"
              v-model="locationCode"
              @input="setSelectedLocationCode"
              class="w-full"
              name="locationCode"
            />
          </vs-col>
        </vs-row>
        <vs-row v-if="isMuckOperationSelected || isHaulingOperationSelected">
          <vs-col class="mb-1" vs-w="12">
            <validated-input
              :label="$t('GradeControl.Timesheet.RoundNumber')"
              v-model="roundNumber"
              name="roundNumber"
            ></validated-input>
          </vs-col>
        </vs-row>

        <vs-row>
          <vs-col class="mb-1" vs-w="12">
            <form-label>{{$t('GradeControl.Timesheet.Destination')}}</form-label>
            <ValidationProvider :name="$t('GradeControl.Timesheet.Destination')" v-slot="{ errors }">
              <v-select
                label="name"
                :options="destinations"
                :reduce="v => v.name"
                v-model="destination"
                @input="setSelectedDestination"
                class="w-full"
              />
              <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
            
          </vs-col>
        </vs-row>
      </div>
    </div>
</template>

<script>
import vSelect from 'vue-select';
import LocationTypeEnum from "./../../LocationTypeEnum.js";
import TimesheetOperationTypeEnum from "../../TimesheetOperationTypeEnum";
import DestinationTypeEnum from "../../DestinationTypeEnum";
import { FormLabel, ValidatedInput, ValidationMessage } from "./../../../../shared/components";

export default {
  name: 'LocationCodeCellEditor',
  data() {
    return {
      locationCode: null,
      locationId: null,
      timesheetOperationType: null,
      locationType: LocationTypeEnum.Production,
      locationTypes: LocationTypeEnum.definition,
      roundNumber: null,
      destination: null,
      timesheetOperationTypes: TimesheetOperationTypeEnum.definition
    }
  },
  computed: {
    locations() {
      return this.params.context.componentParent.locations.filter(l => l.type === this.locationType);
    },
    sourceDestinations() {
      return this.params.context.componentParent.destinations.filter(e => e.destinationType !== DestinationTypeEnum.OrePass);
    },
    destinations() {
      return this.params.context.componentParent.destinations.filter(d => d.name !== this.locationCode);
    },
    initialLocation() {
      if (this.params.value.locationType === null) {
        return this.locationWithRound
      }
      else {
        const typeDef = LocationTypeEnum.getSuffix(this.params.value.locationType);
        return this.locationWithRound + "-" + typeDef;
      }
    },
    initialDestination() {
      return this.params.value.destination;
    },
    initialTimesheetOperationType() {
      return this.params.value.timesheetOperationType;
    },
    locationWithRound() {
      if (this.params.value.roundNumber === null) {
        return this.params.value.locationCode;
      }
      else {
        return this.params.value.locationCode + "-" + this.params.value.roundNumber;
      }
    },    
    isMuckOperationSelected() {
      return this.timesheetOperationType === TimesheetOperationTypeEnum.Muck;
    },
    isHaulingOperationSelected() {
      return this.timesheetOperationType === TimesheetOperationTypeEnum.Hauling;
    },
    isRemuckOperationSelected() {
      return this.timesheetOperationType === TimesheetOperationTypeEnum.Remuck;
    },
    showActualLocation() {
      if (this.locationId !== null && this.locationId !== undefined && this.locations.length > 0) {
        const location = this.locations.find(l => l.locationId === this.locationId);
        if (location) {
          return location.code !== this.locationCode;
        }
      }
      return true;
    }
  },
  components: {
    'v-select': vSelect,
    FormLabel,
    ValidatedInput,
    ValidationMessage
  },
  created() {
    this.timesheetOperationType = this.params.value.timesheetOperationType;
    this.locationId = this.params.value.locationId;
    if (this.locationId !== undefined || this.locationId !== null)
    {
      const locations = this.params.context.componentParent.locations.filter(l => l.locationId === this.locationId);
      if (locations.length > 0) {
        this.locationType = locations[0].type;
      }
    }
    else {
      this.locationType = this.params.value.locationType;
    }
    this.locationCode = this.params.value.locationCode;
    this.roundNumber = this.params.value.roundNumber;
    this.destination = this.params.value.destination;
  },
  methods: {
    getValue() {
      const location = this.locations.find(l => l.locationId === this.locationId);
      if (location) {
        this.locationCode = location.code;
      }
      const locationId = this.locationId;
      const locationCode = this.locationCode;
      const locationType = this.locationType;
      const roundNumber = this.roundNumber;
      const timesheetOperationType = this.timesheetOperationType;
      const destination = this.destination;
      return {
        locationId,
        locationCode,
        locationType,
        roundNumber,
        timesheetOperationType,
        destination
      };
    },
    isPopup() {
      return true;
    },
    setType(type) {
      this.locationType = type;
      this.locationCode = null;
      this.locationId = null;
      this.roundNumber = null;
    },
    setSelectedLocationId(locationId) {
      const location = this.locations.find(l => l.locationId === locationId);
      if (location) {
        this.locationCode = location.code;
      }
      this.locationId  = locationId;
    },
    setSelectedLocationCode(locationCode) {
      this.locationCode = locationCode;
    },
    setSelectedDestination(value) {
      this.destination  = value;
    },
    setSelectedTimesheetOperationType(value) {
      this.timesheetOperationType  = value;
    }
  }
}
</script>
